import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getPatient } from "@/Services/TherapyApi/ClinicalHistory";
import PatientInfoTransformer, {
  type PatientInfoTransformerType,
} from "@/Modules/Transformers/ClinicalHistory/PatientInfo";

import useClinicalHistoryStore from "@/Modules/ClinicalHistory/Store";
import useAppStore from "@/Modules/App/Store";
import useCustomerStore from "@/Modules/Customers/Store";

import { hasValue } from "@/Utils/Objects";

async function getPatientAH(uuid: string | undefined = undefined) {
  const appStore = useAppStore();
  const clinicalHistoryStore = useClinicalHistoryStore();
  const customerStore = useCustomerStore();

  if (!hasValue(customerStore.getCurrentCustomer)) return undefined;

  clinicalHistoryStore.isLoadingPatientInfo = true;

  try {
    const patientInfoApi = await getPatient(uuid ?? customerStore.getCurrentCustomer!.id);
    const patientInfoTransformer: PatientInfoTransformerType = PatientInfoTransformer;
    const patientInfoDomain = patientInfoTransformer.toDomain(patientInfoApi);

    clinicalHistoryStore.patientInfo = patientInfoDomain;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    clinicalHistoryStore.isLoadingPatientInfo = false;
  }
}

export default getPatientAH;
